import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useMedia } from "react-use";
import { Space } from "antd";
import {
  TWO_FACTOR_AUTH,
  USER_TYPE,
  WORKSPACE_USER_TYPE,
} from "constants/appConstant";
import { getIn, useFormik } from "formik";
import * as moment from "moment-timezone";
import { setHeaderTitle, setSubHeaderTitle } from "stores/slices/layout";
import {
  doGetWorkspaceEvent,
  getRealtimeWorkspace,
  getWorkspaceInfo,
} from "stores/slices/workspace";
import {
  isSaving,
  updateWorkspaceSetting,
} from "stores/slices/workspaceSetting";

import AppButton from "components/button";
import FormInput from "components/forms/components/formInput";

import { ClockIcon } from "../../assets/icons";
import { AuthInfo } from "../../stores/slices/auth";

import styles from "../styles.module.scss";

const WorkspaceSettingPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const below1100 = useMedia("(max-width: 1100px)");
  const authInfo = useSelector(AuthInfo);

  const [workspaceInfo, setWorkspaceInfo] = useState(null);
  const [timezoneList, setTimezoneList] = useState([]);
  const [inputItemsTwo, setInputItemsTwo] = useState([]);
  const loading = useSelector(isSaving);
  const workspaceSettingRealtime = useSelector(getRealtimeWorkspace);
  const { workspaceId } = useParams();
  const location = useLocation();

  const doListenWorkspaceSetting = async workspaceId => {
    await dispatch(doGetWorkspaceEvent({ workspaceId: workspaceId }));
  };

  const onSubmitForm = async data => {
    const request = {
      twoFactorAuth: data.twoFactorAuth,
      forceAllUserTwoFactorAuthenticator: data.forceAllUser,
      checkMessage: data.checkWordInMessage,
      maximumNumberSmsSend: data.maximumNumberOfSMS,
      // sendReceiveMms: data.sendAndReceiveMMS,
      scheduleTimeZone: data.timezoneForScheduledMessages,
      timeZone: data.timeZone,
      conversationLockTime: data.lock,
      workspaceId: !workspaceId ? authInfo.workspaceId : workspaceId,
    };

    await dispatch(updateWorkspaceSetting(request));
  };
  const handleForm = useFormik({
    initialValues: {
      twoFactorAuth: TWO_FACTOR_AUTH.NONE,
      forceAllUser: false,
      checkWordInMessage: false,
      maximumNumberOfSMS: 1,
      // sendAndReceiveMMS: false,
      timezoneForScheduledMessages: false,
      lock: null,
    },
    onSubmit: onSubmitForm,
  });
  const { values, setFieldValue, handleSubmit, setValues } = handleForm;

  const twoFactorAuthOption = [
    {
      id: TWO_FACTOR_AUTH.NONE,
      name: t("text.none"),
      disabled: false,
    },
    {
      id: TWO_FACTOR_AUTH.GOOGLE_AUTH,
      name: t("text.googleAuthenticator"),
      disabled: false,
    },
    {
      id: TWO_FACTOR_AUTH.EMAIL,
      name: t("text.email"),
      disabled: false,
    },
  ];

  const inputItemsOne = [
    {
      type: "select",
      key: "twoFactorAuth",
      label: t("text.twoFactor"),
      options: twoFactorAuthOption,
      span: 24,
      noAllowClear: true,
      colon: false,
      style: {
        marginBottom: 0,
        padding: "16px 24px",
        textAlign: below1100 ? "left" : "right",
        borderBottom: "0.5px solid #F4F5F7",
      },
      config: {
        width: "200px",
        textAlign: "center",
        disabled:
          authInfo.workspaceRole === WORKSPACE_USER_TYPE.ADMIN ||
          authInfo.type === USER_TYPE.SUPER_ADMIN
            ? false
            : true,
      },
    },
    {
      type: "switch",
      key: "forceAllUser",
      label: t("text.forceAllUserTwoFactorAuth"),
      span: 24,
      disabled:
        authInfo.workspaceRole === WORKSPACE_USER_TYPE.ADMIN ||
        authInfo.type === USER_TYPE.SUPER_ADMIN
          ? false
          : true,
      colon: false,
      style: {
        marginBottom: 0,
        padding: "16px 24px",
        textAlign: below1100 ? "left" : "right",
        borderBottom: "0.5px solid #F4F5F7",
      },
    },
    // {
    //   type: "switch",
    //   key: "checkWordInMessage",
    //   label: t("text.checkEachMessage"),
    //   span: 24,
    //   disabled:
    //     authInfo.workspaceRole === WORKSPACE_USER_TYPE.ADMIN ||
    //     authInfo.type === USER_TYPE.SUPER_ADMIN
    //       ? false
    //       : true,
    //   colon: false,
    //   style: {
    //     marginBottom: 0,
    //     padding: "16px 24px",
    //     textAlign: below1100 ? "left" : "right",
    //     borderBottom: "0.5px solid #F4F5F7",
    //   },
    // },
  ];

  useEffect(() => {
    let inputItems2 = [
      // {
      //   type: "select",
      //   key: "maximumNumberOfSMS",
      //   label: t("text.selectTheMaximumNumber"),
      //   options: maximumNumberOfSMSOption,
      //   span: 24,
      //   colon: false,
      //   noAllowClear: true,
      //   style: {
      //     marginBottom: 0,
      //     padding: "16px 24px",
      //     textAlign: below1100 ? "left" : "right",
      //     borderBottom: "0.5px solid #F4F5F7",
      //   },
      //   config: {
      //     width: "200px",
      //     textAlign: "center",
      //     disabled:
      //       authInfo.workspaceRole === WORKSPACE_USER_TYPE.ADMIN ||
      //       authInfo.type === USER_TYPE.SUPER_ADMIN
      //         ? false
      //         : true,
      //   },
      // },
      // {
      //   type: "switch",
      //   key: "sendAndReceiveMMS",
      //   label: t("text.sendAndReceiveMMSM"),
      //   span: 24,
      //   disabled:
      //     authInfo.workspaceRole === WORKSPACE_USER_TYPE.ADMIN ||
      //     authInfo.type === USER_TYPE.SUPER_ADMIN
      //       ? false
      //       : true,
      //   colon: false,
      //   style: {
      //     marginBottom: 0,
      //     padding: "16px 24px",
      //     textAlign: below1100 ? "left" : "right",
      //     borderBottom: "0.5px solid #F4F5F7",
      //   },
      // },
      {
        type: "switch",
        key: "timezoneForScheduledMessages",
        label: t("text.timezoneForScheduledMessages"),
        span: 24,
        disabled:
          authInfo.workspaceRole === WORKSPACE_USER_TYPE.ADMIN ||
          authInfo.type === USER_TYPE.SUPER_ADMIN
            ? false
            : true,
        colon: false,
        style: {
          marginBottom: 0,
          padding: "16px 24px",
          textAlign: below1100 ? "left" : "right",
          borderBottom: "0.5px solid #F4F5F7",
        },
      },
      {
        type: "select-search",
        key: "timeZone",
        label: t("label.timezone"),
        placeholder: "label.timezone",
        options: timezoneList,
        icon: <ClockIcon />,
        span: 24,
        colon: false,
        style: {
          marginBottom: 0,
          padding: "16px 24px",
          textAlign: below1100 ? "left" : "right",
          borderBottom: "0.5px solid #F4F5F7",
        },
        config: {
          width: "200px",
          textAlign: "center",
          disabled:
            authInfo.workspaceRole === WORKSPACE_USER_TYPE.ADMIN ||
            authInfo.type === USER_TYPE.SUPER_ADMIN
              ? false
              : true,
        },
        noAllowClear: true,
      },
      {
        type: "number",
        key: "lock",
        label: t("text.conversationLock"),
        placeholder: t("text.conversationLockNumber"),
        span: 24,
        colon: false,
        style: {
          marginBottom: 0,
          padding: "16px 24px",
          width: "100%",
          textAlign: below1100 ? "left" : "right",
        },
        config: {
          addonAfter: "minutes",
          controls: false,
          min: 1,
          max: 999999,
          disabled:
            authInfo.workspaceRole === WORKSPACE_USER_TYPE.ADMIN ||
            authInfo.type === USER_TYPE.SUPER_ADMIN
              ? false
              : true,
        },
      },
    ];
    if (!values.timezoneForScheduledMessages) {
      inputItems2.splice(
        inputItems2.findIndex(i => i.key === "timeZone"),
        1
      );
    }
    setInputItemsTwo(inputItems2);
  }, [values]);

  useEffect(() => {
    if (location.state && location.state.name) {
      dispatch(setHeaderTitle(["setting", "workspace"]));
      dispatch(setSubHeaderTitle(location.state.name));
    } else {
      dispatch(setHeaderTitle("setting"));
    }
  }, []);

  useEffect(() => {
    if (authInfo && authInfo.workspaceId && !workspaceId) {
      loadData(authInfo.workspaceId).then(r => setWorkspaceInfo(r));
    }
  }, [authInfo]);

  useEffect(() => {
    if (workspaceId) {
      loadData(workspaceId).then(r => setWorkspaceInfo(r));
    }
  }, [workspaceId]);

  useEffect(() => {
    const list = moment.tz.names().map(item => {
      return {
        id: item,
        name: item,
      };
    });
    setTimezoneList(list);
    doListenWorkspaceSetting(workspaceId ? workspaceId : authInfo?.workspaceId);
  }, []);

  const loadData = async workspaceId => {
    const { payload } = await dispatch(getWorkspaceInfo(workspaceId));
    return payload;
  };

  useEffect(() => {
    if (workspaceId && workspaceInfo && workspaceInfo.workspaceSetting) {
      setValues({
        twoFactorAuth:
          workspaceInfo.workspaceSetting.twoFactorAuth || TWO_FACTOR_AUTH.NONE,
        forceAllUser:
          workspaceInfo.workspaceSetting.forceAllUserTwoFactorAuthenticator,
        checkWordInMessage: workspaceInfo.workspaceSetting.checkMessage,
        maximumNumberOfSMS: workspaceInfo.workspaceSetting.maximumNumberSmsSend,
        // sendAndReceiveMMS: workspaceInfo.workspaceSetting.sendReceiveMms,
        timezoneForScheduledMessages:
          workspaceInfo.workspaceSetting.scheduleTimeZone,
        lock: workspaceInfo.workspaceSetting.conversationLockTime,
        timeZone: workspaceInfo.workspaceSetting.timeZone,
      });
    }
  }, [workspaceId, workspaceInfo]);

  useEffect(() => {
    if (workspaceSettingRealtime?.settings) {
      setValues({
        twoFactorAuth:
          workspaceSettingRealtime.settings.twoFactorAuth ||
          TWO_FACTOR_AUTH.NONE,
        forceAllUser:
          workspaceSettingRealtime.settings.forceAllUserTwoFactorAuthenticator,
        checkWordInMessage: workspaceSettingRealtime.settings.checkMessage,
        maximumNumberOfSMS:
          workspaceSettingRealtime.settings.maximumNumberSmsSend,
        sendAndReceiveMMS: workspaceSettingRealtime.settings.sendReceiveMms,
        timezoneForScheduledMessages:
          workspaceSettingRealtime.settings.scheduleTimeZone,
        lock: workspaceSettingRealtime.settings.conversationLockTime,
        timeZone: workspaceSettingRealtime.settings.timeZone,
      });
    } else {
      if (workspaceInfo && workspaceInfo.workspaceSetting) {
        setValues({
          twoFactorAuth:
            workspaceInfo.workspaceSetting.twoFactorAuth ||
            TWO_FACTOR_AUTH.NONE,
          forceAllUser:
            workspaceInfo.workspaceSetting.forceAllUserTwoFactorAuthenticator,
          checkWordInMessage: workspaceInfo.workspaceSetting.checkMessage,
          maximumNumberOfSMS:
            workspaceInfo.workspaceSetting.maximumNumberSmsSend,
          sendAndReceiveMMS: workspaceInfo.workspaceSetting.sendReceiveMms,
          timezoneForScheduledMessages:
            workspaceInfo.workspaceSetting.scheduleTimeZone,
          lock: workspaceInfo.workspaceSetting.conversationLockTime,
          timeZone: workspaceInfo.workspaceSetting.timeZone,
        });
      }
    }
  }, [
    workspaceSettingRealtime,
    JSON.stringify(workspaceSettingRealtime?.settings),
  ]);

  return (
    <div className={styles.settingPage}>
      <div className={styles.settingContent}>
        <Space
          direction="vertical"
          size="small"
          style={{
            display: "flex",
            backgroundColor: "#FFFFFF",
            borderRadius: "20px",
            border: "0.5px solid #F4F5F7",
            boxShadow: "2px 5px 9px 0px rgba(16, 24, 40, 0.08)",
          }}
        >
          <FormInput
            items={inputItemsOne.map(item => {
              item.label = t(item.label);
              if (item.key) {
                item.value = getIn(values, item.key);
              }
              return { ...item };
            })}
            form={handleForm}
            onChange={setFieldValue}
            layout={below1100 ? "vertical" : "horizontal"}
          />
        </Space>
        <Space
          direction="vertical"
          size="small"
          style={{
            display: "flex",
            backgroundColor: "#FFFFFF",
            marginTop: "16px",
            borderRadius: "20px",
            border: "0.5px solid #F4F5F7",
            boxShadow: "2px 5px 9px 0px rgba(16, 24, 40, 0.08)",
          }}
        >
          <FormInput
            items={inputItemsTwo.map(item => {
              item.label = t(item.label);
              if (item.key) {
                item.value = getIn(values, item.key);
              }
              return { ...item };
            })}
            form={handleForm}
            onChange={setFieldValue}
            layout={below1100 ? "vertical" : "horizontal"}
          />
        </Space>
        {(authInfo.workspaceRole === WORKSPACE_USER_TYPE.ADMIN ||
          authInfo.type === USER_TYPE.SUPER_ADMIN) && (
          <Space
            size="small"
            style={{ display: "flex", justifyContent: "end", marginTop: 16 }}
          >
            <AppButton
              label={t("label.save")}
              color={"primary"}
              loading={loading}
              type="submit"
              onClick={handleSubmit}
            />
          </Space>
        )}
      </div>
    </div>
  );
};

export default WorkspaceSettingPage;
